import React, { useCallback, useImperativeHandle, useRef } from "react";
import { useEffect, useState, forwardRef } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  TextareaAutosize,
  Tooltip,
  Typography,
  keyframes,
} from "@mui/material";
import { AutoAwesome, CancelOutlined, AccessTime as ClockIcon, ContentCopyOutlined, HistoryOutlined, Info, SmartToy } from "@mui/icons-material";
import { DatePicker, DateTimePicker, TimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import StarRating from "./StarRating.tsx";
import { FieldError } from "../../ScoreCardValidation/ValidationErrors.tsx";
import type { ValidationError } from "../../ScoreCardValidation/ValidationSchema.tsx";
import FileUpload from "./FileUploadBox.tsx";
import CropperModal from "../../CropModel/CropperModal.tsx";
import { ApiCheckInCheckOutShopper, ApiGetPromoterConfig, ApiGetReportHistory, ApiScoreCardStep1, ApiSubmitNetPromoterScore, ApiUpdateAddOnQuestion, ApiUpdateReportBriefJson, ApiUpdateReportVenue } from "../../../apiService/Core/CustomApiScoreCards.tsx";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { ApiCreateStaffManager, ApiGetScenarios, ApiGetStaffManagers, ApiGetVenueList, ApiUpdateCommunication } from "../../../apiService/Core/Apicall.tsx";
import debounce from 'lodash/debounce';
import VoiceInputDialog, { MicButton } from "./Voiceinputdialog.tsx";



dayjs.extend(customParseFormat);
dayjs.extend(utc);

interface RateYourExperienceProps {
  reportDetails: any;
  overviewRefs: any
  AiReviews: any;
  date: Date | null;
  inspectiontime: any
  ratings: any;
  starRatings: any;
  staffMemberDesc: any;
  setStaffMemberDesc: any;
  additionalNoteForShopper: any;
  setAdditionalNoteForShopper: any;
  managerId: any,
  npsData: any,
  setnpsData: any,
  scenarioId: any,
  setManagerId: any,
  setScenarioId: any,
  clientGroup: string;
  reportGroup: string;
  briefJson: any;
  addOnQuestions: any;
  addOnQuestionsData: any;
  textInputs: Record<string, string>;
  reportDetailsHeader: any;
  reportOtherDetails: any;
  shopTypeDetail: any;
  venueName: string;
  setDate: (newDate: Date | null) => void;
  setInspectionTime: (newValue: any) => void;
  onRatingChange: (service: string, value: number) => void;
  onTextChange: (field: string, value: string) => void;
  onAddOnQuestionChange: (field: string, value: string) => void;
  validationErrors?: ValidationError[];
  uploadedFiles: Record<string, File[]>;
  onFileUpload: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string,

  ) => void;
  onFileUpdate: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string,
    index: number,
    questionId?: number,
    reportDetailId?: number
  ) => void;
  onRemoveFile: (section: string, index: number) => void;
  setUploadedFiles: (prevState: any) => void;
  reorderFile: (section: any, from: any, to: any, questionId: any) => void;
  checkIntime: any;
  setcheckIntime: any;
  setselectedVenueData: any;


}

const monthsData = [
  { id: 1, label: "January", value: "january" },
  { id: 2, label: "February", value: "february" },
  { id: 3, label: "March", value: "march" },
  { id: 4, label: "April", value: "april" },
  { id: 5, label: "May", value: "may" },
  { id: 6, label: "June", value: "june" },
  { id: 7, label: "July", value: "july" },
  { id: 8, label: "August", value: "august" },
  { id: 9, label: "September", value: "september" },
  { id: 10, label: "October", value: "october" },
  { id: 11, label: "November", value: "november" },
  { id: 12, label: "December", value: "december" },
];

type VoiceTarget =
  | { type: "staffDesc"; title: string }
  | { type: "additionalNote"; title: string }
  | { type: "nps"; title: string }
  | { type: "summary"; title: string; key: string }
  | { type: "addOn"; title: string; key: string };

const RateYourExperience = forwardRef<any, RateYourExperienceProps>(({
  date,
  reportDetails,
  overviewRefs,
  AiReviews,
  ratings,
  staffMemberDesc,
  setStaffMemberDesc,
  additionalNoteForShopper,
  managerId,
  npsData,
  setnpsData,
  scenarioId,
  setManagerId,
  setScenarioId,
  setAdditionalNoteForShopper,
  starRatings,
  textInputs,
  briefJson,
  reportGroup,
  addOnQuestions,
  addOnQuestionsData,
  reportDetailsHeader,
  reportOtherDetails,
  shopTypeDetail,
  setDate,
  venueName,
  clientGroup,
  onRatingChange,
  onTextChange,
  onAddOnQuestionChange,
  validationErrors = [],
  uploadedFiles,
  onFileUpload,
  onFileUpdate,
  onRemoveFile,
  setUploadedFiles,
  reorderFile,
  checkIntime,
  setcheckIntime,
  setInspectionTime,
  inspectiontime,
  setselectedVenueData
}, ref) => {

  const [selectedMonths, setSelectedMonths] = useState([]);
  const [timeOfVisit, setTimeOfVisit] = useState("");
  const [cropperOpen, setCropperOpen] = useState<boolean>(false);
  const [cropperFile, setCropperFile] = useState<File | null>(null);
  const [cropperSection, setCropperSection] = useState<string>("");
  const [showcheckIn, setshowcheckIn] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [venuelist, setvenuelist] = useState<any>([])
  const [selectedvenue, setselectedvenue] = useState<any>(reportDetailsHeader?.venueId)
  const isAdmin = localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor'
  const [localDesc, setLocalDesc] = useState(staffMemberDesc);
  const [localNotes, setLocalNotes] = useState(additionalNoteForShopper);
  const [localTextInputs, setLocalTextInputs] = useState<any>(textInputs);
  const [localAddOnValues, setLocalAddOnValues] = useState(addOnQuestions);
  const summaryRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const [resportHistory, setReportHistory] = useState<any>(null)
  const [openHistory, setOpenHistory] = useState<boolean>(false)
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);
  const [venueListData, setVenueListData] = useState<any>([])
  const [managerList, setManagerList] = useState<any>([])
  const [scenarioList, setScenarioList] = useState<any>([])
  const [selectedManager, setSelectedManager] = useState<any>(managerId || "")
  const [nps, setNps] = useState<any>(null)
  const [selectedScenario, setSelectedScenario] = useState<any>(scenarioId || "")
  const [managerName, setManagerName] = useState("")
  const [openAddManager, setOpenAddManager] = useState(false)
  const userData = JSON.parse(localStorage.getItem("userData") || "{}")
  const [openNetPromoterInfo, setOpenNetPromoterInfo] = useState(false)
  const [voiceTarget, setVoiceTarget] = useState<VoiceTarget | null>(null);

  const scrollToSummaryField = (id: string) => {

    const element: any = summaryRefs.current[id];
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  useImperativeHandle(ref, () => ({
    scrollToSummaryField,
  }));

  const handleChange = (event) => {
    setSelectedMonths(event.target.value);
  };
  // const handleChange2 = async (event: any) => {
  //   setStaffMemberDesc(event.target.value);
  //   try {
  //     const data =
  //     {
  //       "reportHeaderId": reportDetailsHeader?.reportHeaderId,
  //       platform: "web",
  //       platformAppType: null,
  //       teamMemberDescription: event.target.value,

  //     }
  //     const res = isAdmin ? await ApiScoreCardStep1(data, clientGroup) : (event.target.value)?.trim() !== "" && await ApiScoreCardStep1(data, clientGroup)

  //   } catch (error: any) {
  //     toast.error(error?.message)
  //   }
  // };
  // const handleChangeAdditionalNote = async (event: any) => {
  //   setAdditionalNoteForShopper(event.target.value);
  //   try {
  //     const data =
  //     {
  //       "reportHeaderId": reportDetailsHeader?.reportHeaderId,
  //       platform: "web",
  //       platformAppType: null,
  //       additionalNoteForShopper: event.target.value,

  //     }
  //     const res = isAdmin ? await ApiScoreCardStep1(data, clientGroup) : event.target.value?.trim() !== "" && await ApiScoreCardStep1(data, clientGroup)

  //   } catch (error: any) {
  //     toast.error(error?.message)
  //   }
  // };


  const saveStaffDesc = async (value: string) => {
    setStaffMemberDesc(value);
    try {
      const data = {
        reportHeaderId: reportDetailsHeader?.reportHeaderId,
        platform: "web",
        platformAppType: null,
        teamMemberDescription: value,
      };
      isAdmin
        ? await ApiScoreCardStep1(data, clientGroup)
        : value?.trim() !== "" && (await ApiScoreCardStep1(data, clientGroup));
    } catch (error: any) {
      toast.error(error?.message);
    }
  };
  const handleChange2 = (event: any) => saveStaffDesc(event.target.value);

  const saveAdditionalNote = async (value: string) => {
    setAdditionalNoteForShopper(value);
    try {
      const data = {
        reportHeaderId: reportDetailsHeader?.reportHeaderId,
        platform: "web",
        platformAppType: null,
        additionalNoteForShopper: value,
      };
      isAdmin
        ? await ApiScoreCardStep1(data, clientGroup)
        : value?.trim() !== "" && (await ApiScoreCardStep1(data, clientGroup));
    } catch (error: any) {
      toast.error(error?.message);
    }
  };

  const handleChangeAdditionalNote = (event: any) => saveAdditionalNote(event.target.value);


  const getVoiceInitialText = (t: VoiceTarget | null): string => {
    if (!t) return "";
    switch (t.type) {
      case "staffDesc": return localDesc || "";
      case "additionalNote": return localNotes || "";
      case "nps": return nps?.feedback || "";
      case "summary": return localTextInputs[t.key] || "";
      case "addOn": return localAddOnValues[t.key] || "";
    }
  };

  const applyVoiceText = (t: VoiceTarget, text: string) => {
    switch (t.type) {
      case "staffDesc":
        setLocalDesc(text);
        saveStaffDesc(text);
        break;
      case "additionalNote":
        setLocalNotes(text);
        saveAdditionalNote(text);
        break;
      case "nps":
        setNps((prev: any) => ({ ...prev, feedback: text }));
        handleChangeNPS({
          score: nps?.score,
          feedback: text.trim(),
          netPromoterScoreConfigId: nps?.netPromoterScoreConfigId,
          reportHeaderId: reportDetailsHeader?.reportHeaderId,
        });
        break;
      case "summary":
        handleSummary(t.key, text);
        updateBriefJson(t.key, text); // also calls onTextChange
        break;
      case "addOn":
        handleLocalChange(t.key, text);
        handleBlur(t.key, text);
        break;
    }
  };

  useEffect(() => {
    if (reportDetailsHeader) {
      setSelectedMonths(reportDetailsHeader.reportMonth);
      //     const visitDate = date;
      //     const hours = visitDate?.getHours().toString().padStart(2, "0"); // Ensure two digits
      //     const minutes = visitDate?.getMinutes().toString().padStart(2, "0"); // Ensure two digits
      //     // setTimeOfVisit(`${hours}:${minutes}`); // Set formatted time
    }
    //   //setDate(date)
  }, [reportDetailsHeader]);

  const handleOpenCropper = (file: File, section: string) => {
    setCropperFile(file);
    setCropperSection(section);
    setCropperOpen(true);
  };
  // console.log("Validatioons Error", validationErrors)

  const handleCheckAction = async () => {

    const confirmationMessage = "Are you sure you want to check in?"

    const userConfirmed = window.confirm(confirmationMessage);
    if (!userConfirmed) return;

    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        // const { latitude, longitude } = {};
        const params = {
          jobMonth: date && date?.getMonth() + 1,
          jobYear: date && date?.getFullYear(),
          userId: reportDetailsHeader.userId,
        };

        try {
          const payload = {
            type: "checkIn",
            shopperLatitude: position.coords.latitude,
            shopperLongitude: position.coords.longitude,
            allocationId: reportDetailsHeader.allocationId,
            platform: "web",
            platformAppType: null
          };
          // console.log("Send Data", payload)
          const response = await ApiCheckInCheckOutShopper(payload, reportGroup);
          toast.success(response.message);
          localStorage.setItem("IsCheckInSuccessfull", "true")
        } catch (error: any) {
          toast.error(`Check In failed: ${error?.message}`);
        }
      },
      (error) => {
        toast.error("Error white getting location")
        console.error("Error getting location:", error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  };

  // console.log("Staff Member Descipion", staffMemberDesc)

  // Update parent state only after 500ms of no typing

  useEffect(() => {
    setLocalDesc(staffMemberDesc)
  }, [staffMemberDesc])

  useEffect(() => {
    setLocalNotes(additionalNoteForShopper)
  }, [additionalNoteForShopper])

  useEffect(() => {
    setLocalAddOnValues(addOnQuestions)
  }, [addOnQuestions])

  useEffect(() => {
    setSelectedManager(managerId)
  }, [managerId])

  useEffect(() => {
    setSelectedScenario(scenarioId)
  }, [scenarioId])

  useEffect(() => {
    setnpsData(nps)
  }, [nps])

  useEffect(() => {
    if (!nps) {
      setNps(npsData)
    }
  }, [npsData])


  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     if (localDesc !== staffMemberDesc) {
  //       setStaffMemberDesc(localDesc);
  //     }
  //   }, 1000);

  //   return () => clearTimeout(handler);
  // }, [localDesc, localTextInputs]);

  // Handle input instantly (smooth typing)
  const handleChangeDescription = useCallback((e: any) => {
    setLocalDesc(e.target.value);
  }, []);

  const handleChangeAdditionalNotes = useCallback((e: any) => {
    setLocalNotes(e.target.value);
  }, []);


  // Keep local state in sync when data changes externally (like loading saved data)
  useEffect(() => {
    // run only if localTextInputs is empty
    if (Object.keys(localTextInputs).length === 0) {
      setLocalTextInputs(textInputs);
    }
  }, [textInputs]);


  // Debounce each input’s update separately
  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     // Compare keys and update only changed ones
  //     for (const key in localTextInputs) {
  //       if (localTextInputs[key] !== textInputs[key]) {
  //         onTextChange(key, localTextInputs[key]);
  //       }
  //     }
  //   }, 500); 

  //   return () => clearTimeout(handler);
  // }, [localTextInputs]);

  // Handle input instantly (smooth typing)
  const handleSummary = useCallback((id: any, value: any) => {
    setLocalTextInputs((prev) => ({
      ...prev,
      [id]: value,
    }));
  }, []);

  const handleLocalChange = (key: string, value: string) => {
    setLocalAddOnValues((prev: any) => ({
      ...prev,
      [key]: value
    }));
  };


  const updateBriefJson = async (fieldKey: any, value: any) => {
    try {
      const data =
      {
        "reportHeaderId": reportDetailsHeader?.reportHeaderId,
        platform: "web",
        platformAppType: null,
        "briefJson": [{
          reportBriefJsonId: fieldKey,
          briefJsonAnswer: value
        }]

      }
      const res = isAdmin ? await ApiUpdateReportBriefJson(data, clientGroup) : value?.trim() !== "" && await ApiUpdateReportBriefJson(data, clientGroup)
      onTextChange(fieldKey, value);
    } catch (error) {
      toast.error("Error While Saving Brief Json")
      console.log("Error While Saving Brief Json", error)
    }
  }


  const handlegetvenuelist = async () => {
    try {
      const data = `?clientEntityId=${reportDetailsHeader?.clientEntityId}&venueStatus=active&offset=0&limit=1000`
      const res = await ApiGetVenueList(data)
      if (res.data) {
        setVenueListData(res?.data)
        setvenuelist(res?.data?.map((item: any) => ({
          venueId: item?.venueId,
          venueName: item?.venueName
        })))
      }
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  useEffect(() => {
    reportDetailsHeader && isAdmin && handlegetvenuelist()
  }, [reportDetailsHeader])


  useEffect(() => {
    if (isAdmin) {
      const saved = localStorage.getItem("selectedVenue");

      if (saved) {
        setselectedvenue(saved);
      } else {
        setselectedvenue(reportDetailsHeader?.venueId || "");
      }
    }
  }, [venueName]);

  const handleVenueChange = async (value) => {
    if (isAdmin) {
      try {
        const data = {
          "reportHeaderId": reportDetailsHeader?.reportHeaderId,
          platform: "web",
          platformAppType: null,
          "allocationId": reportDetailsHeader?.allocationId,
          "venueId": value,
          "modifiedBy": localStorage.getItem('liveuserId') || 0
        }
        const res = await ApiUpdateReportVenue(data, clientGroup)
        if (res.status) {
          return
        }
      } catch (error: any) {

        toast.error(error?.message)
      }
    }
  }

  useEffect(() => {
    selectedvenue && venueListData && isAdmin && setselectedVenueData(venueListData?.find((item: any) => item?.venueId == selectedvenue))
  }, [selectedvenue, venueListData])

  const handleBlur = async (key: string, value: string) => {
    try {
      const data =
      {
        "reportHeaderId": reportDetailsHeader?.reportHeaderId,
        platform: "web",
        platformAppType: null,
        "addOnQuestions": [{
          reportAddOnQuestionId: key,
          addOnQuestionValue: value
        }]

      }
      const res = await ApiUpdateAddOnQuestion(data, clientGroup)
      onAddOnQuestionChange(key, value);
    } catch (error) {
      toast.error("Error While Saving Brief Json")
      console.log("Error While Saving Brief Json", error)
    }
  };

  const getHistory = async (data: any) => {
    try {
      const res = await ApiGetReportHistory(data, clientGroup)
      if (res?.status) {
        setReportHistory(res?.data)
        setOpenHistory(true)
      }
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const getManagerList = async () => {
    try {
      const data = `?offset=0&limit=100&venueId=${reportDetails?.allocationDetails?.venueId?.venueId}&allocationId=${reportDetails?.allocationDetails?.allocationId}`
      const res = await ApiGetStaffManagers(data)
      if (res?.status) {
        setManagerList(res?.data)
      }
    } catch (error: any) {
      toast.error(error?.message)
    }
  }
  const getScenarioList = async () => {
    try {
      const data = `?offset=0&limit=100&clientEntityId=${reportDetails?.allocationDetails?.clientEntityId?.clientEntityId}&venueId=${reportDetails?.allocationDetails?.venueId?.venueId}&allocationId=${reportDetails?.allocationDetails?.allocationId}`
      const res = await ApiGetScenarios(data)
      if (res?.status) {
        setScenarioList(res?.data)
      }
    } catch (error: any) {
      toast.error(error?.message)
    }
  }



  const handleCommunication = async () => {
    try {
      const data = {
        allocationId: reportDetails?.allocationDetails?.allocationId,
        managerId: selectedManager,
        scenarioId: selectedScenario
      }
      const res = await ApiUpdateCommunication(data)
      if (res.status) {
        return
      }
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  useEffect(() => {
    if (reportDetails?.allocationDetails?.venueId?.isEnableManagerScenarioDiscussion) {
      getManagerList()
      getScenarioList()
    }
  }, [reportDetails])


  useEffect(() => {
    if (selectedManager && selectedScenario) {
      handleCommunication()
    }
  }, [selectedManager, selectedScenario])


  // useEffect(()=>{
  //   if(reportDetails?.allocationDetails?.venueId?.isEnableManagerScenarioDiscussion){
  //   if(reportDetails?.allocationDetails?.managerId?.managerId){
  //     setSelectedManager(reportDetails?.allocationDetails?.managerId?.managerId)
  //   }
  //   if(reportDetails?.allocationDetails?.scenarioId?.scenarioId){
  //     setSelectedScenario(reportDetails?.allocationDetails?.scenarioId?.scenarioId)
  //   }
  //   }
  // },[reportDetails])


  const CretaeStaff = async () => {
    if (managerName?.trim().length < 1) {
      window.alert("Please add Manager Name");
      return;
    }

    try {
      const data = {
        managerName: managerName?.trim(),
        venueId: reportDetails?.allocationDetails?.venueId?.venueId,
        createdBy: userData?.userId || localStorage?.getItem('liveuserId') || 9218,
      };

      const res = await ApiCreateStaffManager(data);

      if (res?.data) {
        setManagerName("");
        setOpenAddManager(false);
        getManagerList()
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const getPromoterConfig = async () => {
    try {
      const data = `?score=${nps?.score}`
      const res = await ApiGetPromoterConfig(data, clientGroup)
      if (res?.status) {
        setNps((prev: any) => ({
          ...prev,
          netPromoterScoreConfigId: res?.data?.netPromoterScoreConfigId,
          title: res?.data?.title
        }))

        const data = {
          score: nps.score,
          feedback: nps?.feedback || "",
          netPromoterScoreConfigId: res?.data?.netPromoterScoreConfigId,
          reportHeaderId: reportDetailsHeader?.reportHeaderId
        }
        handleChangeNPS(data)
      }
    } catch (error) {
      console.log('Error While getting protoer details', error)
    }
  }

  useEffect(() => {
    nps?.score > -1 && getPromoterConfig()
  }, [nps?.score])
  // console.log("repprt Headre Details", reportDetailsHeader)

  const handleChangeNPS = async (data: any) => {
    try {
      const res = await ApiSubmitNetPromoterScore(data, clientGroup)

    } catch (error: any) {
      toast.error("Error", error)
    }
  }


  const npsOptions = [
    { value: 0, label: "Very poor experience with significant issues." },
    { value: 1, label: "Very poor experience with significant issues." },
    { value: 2, label: "Very poor experience with significant issues." },

    { value: 3, label: "Several aspects of the experience fell below expectations." },
    { value: 4, label: "Several aspects of the experience fell below expectations." },

    { value: 5, label: "Average experience. Positives and negatives balanced." },
    { value: 6, label: "Average experience. Positives and negatives balanced." },

    { value: 7, label: "Good experience with some minor areas for improvement." },
    { value: 8, label: "Good experience with some minor areas for improvement." },

    { value: 9, label: "Outstanding experience. Very few, if any, improvements could be made." },
    { value: 10, label: "Outstanding experience. Very few, if any, improvements could be made." },
  ];

  return (
    <Stack spacing={4}>
      {starRatings.length > 0 && (
        <Box>
          <Typography variant="h5" fontWeight={600}>
            Rate Your Experience
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please give a star rating out of 5. 1 is the lowest, and 5 is the highest.
          </Typography>
        </Box>
      )}

      <Grid container spacing={3} style={{ gap: "20px" }}>
        {starRatings.map((starRating) => (
          <Grid
            item
            className="starRatingBox"
            style={{ maxWidth: "500px" }}
            xs={12}
            md={4}
            key={starRating.reportStarRatingId}
          >
            <StarRating
              key={starRating.reportStarRatingId}
              service={starRating.reportStarRatingId.toString()} // Ensure key is unique
              label={starRating.starRatingDesc}
              rating={
                ratings[starRating.reportStarRatingId] ||
                starRating.starRatingScore
              } // Ensure updated rating is passed
              required={true}
              onRatingChange={onRatingChange}
              error={validationErrors.some(
                (e) => e.field === `rating_${starRating.reportStarRatingId}`
              )}
            />
            <FieldError
              errors={validationErrors}
              field={`rating_${starRating.reportStarRatingId}`}
            />
          </Grid>
        ))}
      </Grid>

      {reportDetails?.allocationDetails?.clientEntityId?.isNPSenable && (

        <Grid container spacing={1.5} className="w-100">
          <Grid xs={6}>
            <Box className='d-flex align-items-center gap-2'>
              <Typography className="mb-1" sx={{ color: "#0000008A" }} fontSize={'14px'}>Select Net Promoter Score
              </Typography>
              <IconButton className="m-0 p-0" onClick={() => { setOpenNetPromoterInfo(true) }}>
                <Info className="text-main m-0 p-0" fontSize="small"></Info>
              </IconButton>
              {isAdmin && (
                <Tooltip title='see history'>
                  <IconButton onClick={() => { getHistory(`?reportHeaderId=${reportDetailsHeader?.reportHeaderId}&npsData=true`) }} className="m-0 p-0">
                    <HistoryOutlined />
                  </IconButton>
                </Tooltip>
              )}
            </Box>

            <FormControl fullWidth size="small">
              <Select
                value={nps?.score ?? ""}
                onChange={(e) => {
                  setNps((prev: any) => ({
                    ...prev,
                    score: e.target.value,
                  }));
                }}
                sx={{
                  borderColor: validationErrors.some(
                    (e) => e.field === "npsScore"
                  )
                    ? "#d32f2f"
                    : undefined,
                  borderRadius: "10px",
                }}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select Net Promoter Score
                </MenuItem>

                {npsOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.value} - {option.label}
                  </MenuItem>
                ))}
              </Select>
              <FieldError errors={validationErrors} field="npsScore" />
            </FormControl>
          </Grid>
          {nps?.title && reportDetails?.allocationDetails?.clientEntityId?.isNPSFeedbackRequired && (
            <Grid xs={12} className="mt-4">
              <Box position={'relative'}>

                <Typography className="mb-1" sx={{ color: "#0000008A" }} fontSize={'14px'}>{nps?.title}</Typography>
                <MicButton
                  sx={{ position: "absolute", top: -10, right: 8 }}
                  onClick={() => setVoiceTarget({ type: "nps", title: "Speak your feedback" })}
                />
              </Box>
              <TextareaAutosize
                minRows={5}
                placeholder={`Based on your overall experience today, how likely would you be to recommend this business to a friend, family member or colleague?
Rate from 0 to 10, where:
10 = Extremely likely to recommend
0 = Not at all likely to recommend
Shopper Hint:
Consider your entire experience, from start to finish. Think about the service you received, the quality of the product or service, the atmosphere, value for money, and whether the business met your expectations. Rate how likely you would genuinely be to recommend this business based on today's visit, not on previous experiences or personal preferences. Please explain why you gave this score. Tell us the main reason for your rating.
Mention the key positive and/or negative aspects that most influenced your decision to recommend (or not recommend) the business.`}
                defaultValue={nps?.feedback}
                onChange={(e) =>
                  setNps((prev: any) => ({
                    ...prev,
                    feedback: e.target.value,
                  }))
                }
                onBlur={(e) => {
                  const data = {
                    score: nps?.score,
                    feedback: e.target?.value?.trim(),
                    netPromoterScoreConfigId: nps?.netPromoterScoreConfigId,
                    reportHeaderId: reportDetailsHeader?.reportHeaderId
                  }
                  setNps((prev: any) => ({
                    ...prev,
                    feedback: e.target.value?.trim(),
                  }))
                  handleChangeNPS(data)
                }
                }
                // className=bt-transparent w-100 mt-0"
                // onChange={handleChange2}
                // onInput={handleChangeDescription}
                className={`bt-transparent w-100 mt-0 ${validationErrors.some((e) => (e.field === "npsFeedback" || e.field === "npsComment"))
                  ? "error-border"
                  : ""
                  }`}
                style={{
                  borderColor: validationErrors.some(
                    (e) => e.field === "npsFeedback"
                  )
                    ? "#d32f2f"
                    : undefined,
                  borderRadius: "10px",
                }}
              />
              <FieldError errors={validationErrors} field="npsFeedback" />
              <FieldError errors={validationErrors} field="npsComment" />
            </Grid>
          )}
        </Grid>
      )}

      {reportDetails?.allocationDetails?.venueId?.isEnableManagerScenarioDiscussion && (
        <Grid container spacing={2} className="w-100" justifyContent={'space-between'}>
          <Grid xs={5.95}>
            <Typography className="mb-1" sx={{ color: "#0000008A" }} fontSize={'14px'}>Staff Member</Typography>
            <FormControl fullWidth size="small">
              <Select
                key={selectedManager}
                value={selectedManager || ""}
                onChange={(e) => { setSelectedManager(e.target.value); setManagerId(e.target.value) }}
                // displayEmpty
                sx={{
                  borderRadius: "10px",
                }}
              >
                <MenuItem value="" disabled>
                  Select Staff Member
                </MenuItem>

                {managerList?.map((manager: any) => (
                  <MenuItem key={manager.managerId} value={manager.managerId}>
                    {manager.managerName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="caption" className="mt-5" color="text.secondary">
              <span className="third-text fw-bold pointer" style={{ cursor: 'pointer' }} onClick={() => { setOpenAddManager(true) }} >"+ Add Staff Member"</span>
            </Typography>
          </Grid>
          <Grid xs={5.95}>
            <Typography className="mb-1" sx={{ color: "#0000008A" }} fontSize={'14px'}>Cues</Typography>
            <FormControl fullWidth size="medium"
              sx={{
                "& .MuiOutlinedInput-root": {
                  minHeight: '48px !important',
                  height: "fit-content !important",
                }
              }}
            >
              <Select
                key={selectedScenario}
                value={selectedScenario || ""}
                onChange={(e) => { setSelectedScenario(e.target.value); setScenarioId(e.target.value) }}
                // displayEmpty
                // sx={{
                //   borderRadius: "10px",
                // }}
                sx={{
                  borderRadius: "10px",
                  "& .MuiSelect-select": {
                    whiteSpace: "normal",   // Allow wrapping
                    wordBreak: "break-word",
                    display: "block",
                    height: "auto !important",
                    minHeight: "24px",
                    padding: '8px !important'
                  },

                  "& .MuiOutlinedInput-root": {
                    minHeight: '48px !important',
                    height: "fit-content !important",
                  }
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      "& .MuiMenuItem-root": {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        lineHeight: 1.4,
                        py: 1,

                      },
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select Cues
                </MenuItem>

                {scenarioList?.map((scenario: any) => (
                  <MenuItem key={scenario.scenarioId} value={scenario.scenarioId}>
                    {scenario.scenarioName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      )}

      <Card sx={{ backgroundColor: "inherit" }}>
        <Typography variant="h5" fontWeight={600}>
          Score Card
        </Typography>
        {/* <Typography variant="body2" color="text.secondary">
          {(reportGroup === "MM" || reportGroup === "BLOOMS") ? " Do not use your Membership Card." : ""} Your movement may be tracked by CCTV.
        </Typography> */}
        <Grid container spacing={3} className="mt-0 w-100">
          <Grid item xs={6} >
            <Typography className="mb-1" sx={{ color: "#0000008A" }} fontSize={'14px'}>Report Month</Typography>
            <Typography border={'1px solid #0000005A'} padding={'11px'} className=" border-10 fw-bolder" variant="subtitle2">{reportDetailsHeader?.reportMonth}/{reportDetailsHeader?.reportYear}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className="mb-1" sx={{ color: "#0000008A" }} fontSize={'14px'}>Venue Name</Typography>
            {isAdmin ? (<FormControl fullWidth size="small">
              <Select
                key={selectedvenue}
                value={selectedvenue || venueName || ""}
                onChange={(e) => { setselectedvenue(e.target.value); handleVenueChange(e?.target?.value) }}
                // displayEmpty
                sx={{
                  borderRadius: "10px",
                }}
              >
                <MenuItem value="" disabled>
                  Select venue
                </MenuItem>

                {venuelist?.map((venue: any) => (
                  <MenuItem key={venue.id} value={venue.venueId}>
                    {venue.venueName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            ) :
              (<Typography border={'1px solid #0000005A'} padding={'11px'} className=" border-10 fw-bolder" variant="subtitle2">{venueName}</Typography>)}

          </Grid>
        </Grid>
        <Stack spacing={4} sx={{ backgroundColor: "inherit" }}>
          <Card sx={{ backgroundColor: "inherit" }}>
            <CardContent>
              <Grid container spacing={{ xs: 2, sm: 3 }}>
                <Grid item xs={12} md={4} className="scoreCardBox">
                  <FormControl fullWidth>
                    <InputLabel shrink={false}>
                      Visit Month{" "}
                      <span style={{ color: "#D32F2F" }}> *</span>
                    </InputLabel>
                    <TextField
                      select
                      // disabled
                      // label="Mystery Shop Month*"
                      value={selectedMonths}
                      onChange={handleChange}
                      fullWidth
                    >
                      {monthsData.map((month) => (
                        <MenuItem key={month.id} value={month.id}>
                          {month.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                </Grid>


                <Grid item xs={12} md={4} className="scoreCardBox">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <FormControl
                      fullWidth
                      error={validationErrors.some((e) => e.field === "date")}
                      data-field="date"
                    >
                      <InputLabel shrink={false}>
                        Date of Visit{" "}
                        <span style={{ color: "#D32F2F" }}> *</span>
                      </InputLabel>
                      <DatePicker
                        value={date ? dayjs(date) : null}
                        onChange={setDate}
                        disabled={!isAdmin}
                        // maxDate={
                        //   reportDetails?.reportHeader?.inspectionDateTime
                        //     ? dayjs(reportDetails.reportHeader.inspectionDateTime.split(" ")[0])
                        //     : undefined
                        // }
                        format="DD-MM-YYYY"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            error={validationErrors.some(
                              (e) => e.field === "date"
                            )}
                          />
                        )}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <ClockIcon sx={{ color: "text.secondary" }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <FieldError errors={validationErrors} field="date" />
                    </FormControl>
                  </LocalizationProvider>
                </Grid>
                <Grid sx={{
                  position: "relative",
                }} item xs={12} md={4} className="scoreCardBox">
                  <InputLabel className="mb-1 ms-3 mt-3" shrink={false}>Time of Visit <span style={{ color: "#D32F2F" }}> *</span></InputLabel>
                  <TextField error={validationErrors.some(
                    (e) => e.field === "inspectiontime"
                  )} data-field="inspectiontime" className="mt-0" value={inspectiontime ?? ''} onChange={(e: any) => { setInspectionTime(e.target.value) }} />
                  <IconButton onClick={() => setOpen(true)}>
                    <AccessTimeIcon />
                  </IconButton>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box sx={{
                      "& .MuiOutlinedInput-root": {
                        border: "none"
                      }
                    }}>
                      <TimePicker
                        open={open}
                        onClose={() => setOpen(false)}
                        sx={{
                          position: 'absolute',
                          top: '0px',
                          "& .MuiIconButton-root": {
                            display: "none"
                          },
                          "& .MuiOutlinedInput-root": {
                            border: "none",
                            // display:'none',
                            color: 'transparent',
                            backgroundColor: "transparent",
                            "& fieldset": {
                              borderColor: "transparent",
                            },
                            "&:hover fieldset": {
                              borderColor: "transparent",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "transparent !important",
                            },
                          },
                          "& .MuiInputBase-input": {
                            userSelect: "none", // disables text selection highlight
                            backgroundColor: "transparent",
                            WebkitUserSelect: "none",
                            MozUserSelect: "none",
                            msUserSelect: "none",
                          },
                          "& .MuiInputBase-root": {
                            backgroundColor: "transparent",
                          },
                        }}
                        // value={inspectiontime}
                        onChange={(newTime) => setInspectionTime(dayjs(newTime).format("hh:mm A"))}
                        renderInput={(params) => (
                          <TextField
                            {...params}

                          />
                        )}
                      />
                    </Box>

                  </LocalizationProvider>
                  <FieldError errors={validationErrors} field="inspectiontime" />
                </Grid>


                {/* <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                  <InputLabel shrink={false}>Time of Visit*</InputLabel>
                    <TextField
                      // label=""
                      placeholder="HH:MM"
                      value={timeOfVisit} // Bind the extracted time here
                      onChange={(e) => setTimeOfVisit(e.target.value)} // Allow manual update
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <ClockIcon sx={{ color: "text.secondary" }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </Grid> */}
              </Grid>
            </CardContent>
          </Card>
        </Stack>
      </Card>


      {clientGroup !== "TRANSPORT" && (reportDetails?.reportHeader?.clientEntityId != 128) && (<Box data-field="staffMemberDesc">
        <Box className='d-flex align-items-center' sx={{ mb: 2, position: 'relative' }} gap={1}>
          <Typography variant="h5" fontWeight={600}>
            {reportGroup === "ALDI" ? "Auditor's notes" : reportGroup === "BLOOMS" ? "Pharmacists/Team Members" : 'Staff Member Description'}
            {
              (reportDetails?.entityTypeDetails?.entityTypeName?.toLowerCase().includes("bottleshop") ||
                reportDetails?.entityTypeDetails?.entityTypeName?.toLowerCase().includes("food") ||
                reportDetails?.entityTypeDetails?.entityTypeName?.toLowerCase().includes("fb") ||
                reportDetails?.entityTypeDetails?.entityTypeName?.toLowerCase().includes("fbg") ||
                reportDetails?.entityTypeDetails?.entityTypeName?.toLowerCase().includes("gaming") ||
                reportDetails?.entityTypeDetails?.entityTypeName?.toLowerCase().includes("bar"))
              && (
                <Tooltip className="ms-1" title='Please describe all staff/team members you come into contact with, using either their name (if wearing a badge) OR a description. The description should include Gender, Cultural appearance, hair colour & style, clothing and any defining features. For example: BAR1: Jan or BIS1: Male, African appearance, short black hair, branded polo shirt, jeans, black shoes, tattoo on right forearm. Never mention age, build, weight, or perceived attractiveness. Once you have described them, please use their descriptor, e.g., BAR1, when referring to them throughout the report.'><Info></Info></Tooltip>
              )
            }
            {
              (reportGroup === "BLOOMS")
              && (
                <Tooltip className="ms-1" title='Please describe all staff/team members you come into contact with, using either their name (if wearing a badge) OR a description. The description should include Gender, hair colour & style, clothing and any defining features. For example: TM1: John or PHARM1: Female, African appearance, short black hair, white coat, black shoes, chunky gold bracelet on right arm. Never mention age, cultural appearance, build, weight, or perceived attractiveness. Once you have described them, please use their descriptor, e.g., PHARM1, when referring to them throughout the report.'><Info></Info></Tooltip>
              )
            }
          </Typography>
          {isAdmin && (
            <Tooltip title='see history'>
              <IconButton onClick={() => { getHistory(`?reportHeaderId=${reportDetailsHeader?.reportHeaderId}&teamMemberDescription=true`) }} className="m-0 p-0">
                <HistoryOutlined />
              </IconButton>
            </Tooltip>
          )}
          <MicButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setVoiceTarget({ type: "staffDesc", title: "Speak your notes" })}
          />
        </Box>
        <Box sx={{ position: 'relative !important' }}>
          <TextareaAutosize
            minRows={5}

            placeholder={
              (reportDetails?.entityTypeDetails?.entityTypeName?.toLowerCase().includes("bottleshop") ||
                reportDetails?.entityTypeDetails?.entityTypeName?.toLowerCase().includes("food") ||
                reportDetails?.entityTypeDetails?.entityTypeName?.toLowerCase().includes("fb") ||
                reportDetails?.entityTypeDetails?.entityTypeName?.toLowerCase().includes("fbg") ||
                reportDetails?.entityTypeDetails?.entityTypeName?.toLowerCase().includes("gaming") ||
                reportDetails?.entityTypeDetails?.entityTypeName?.toLowerCase().includes("bar"))
                ? (
                  'Please describe all staff/team members you come into contact with, using either their name (if wearing a badge) OR a description. The description should include Gender, Cultural appearance, hair colour & style, clothing and any defining features. For example: BAR1: Jan or BIS1: Male, African appearance, short black hair, branded polo shirt, jeans, black shoes, tattoo on right forearm. Never mention age, build, weight, or perceived attractiveness. Once you have described them, please use their descriptor, e.g., BAR1, when referring to them throughout the report.'
                )
                :
                (reportGroup === "BLOOMS")
                  ? (
                    'Please describe all staff/team members you come into contact with, using either their name (if wearing a badge) OR a description. The description should include Gender, hair colour & style, clothing and any defining features. For example: TM1: John or PHARM1: Female, African appearance, short black hair, white coat, black shoes, chunky gold bracelet on right arm. Never mention age, cultural appearance, build, weight, or perceived attractiveness. Once you have described them, please use their descriptor, e.g., PHARM1, when referring to them throughout the report.'
                  )
                  :
                  "Write Here"
            }
            defaultValue={localDesc}
            onChange={handleChangeDescription}
            onBlur={handleChange2}
            // onChange={handleChange2}
            // onInput={handleChangeDescription}
            className={`summeryBox ${validationErrors.some((e) => e.field === "staffMemberDesc")
              ? "error-border"
              : ""
              }`}
            style={{
              borderColor: validationErrors.some(
                (e) => e.field === "staffMemberDesc"
              )
                ? "#d32f2f"
                : undefined,
              borderRadius: "10px",
            }}
          />

        </Box>
        <FieldError errors={validationErrors} field="staffMemberDesc" />
      </Box>
      )}

      {clientGroup === "BLOOMS" && (
        <Box data-field="additionalNoteForShopper">
          <Box className='d-flex align-items-center' sx={{ mb: 2 }} gap={1}>
            <Typography variant="h5" fontWeight={600}>
              Additional Note
              {/* <Tooltip className="ms-1" title='Please describe all staff/team members you come into contact with, using either their name (if wearing a badge) OR a description. The description should include Gender, hair colour & style, clothing and any defining features. For example: TM1: John or PHARM1: Female, African appearance, short black hair, white coat, black shoes, chunky gold bracelet on right arm. Never mention age, cultural appearance, build, weight, or perceived attractiveness. Once you have described them, please use their descriptor, e.g., PHARM1, when referring to them throughout the report.'><Info></Info></Tooltip> */}
            </Typography>
          </Box>

          <TextareaAutosize
            minRows={5}
            placeholder={"Tell us what health issue you asked about. e.g Constipation, Cold & Flu symptoms, etc"}
            defaultValue={localNotes}
            onChange={handleChangeAdditionalNotes}
            onBlur={handleChangeAdditionalNote}
            // onChange={handleChange2}
            // onInput={handleChangeDescription}
            className={`summeryBox ${validationErrors.some((e) => e.field === "additionalNoteForShopper")
              ? "error-border"
              : ""
              }`}
            style={{
              borderColor: validationErrors.some(
                (e) => e.field === "additionalNoteForShopper"
              )
                ? "#d32f2f"
                : undefined,
              borderRadius: "10px",
            }}
          />
          <FieldError errors={validationErrors} field="additionalNoteForShopper" />
        </Box>
      )}

      {/* {localStorage.getItem('liveclientGroup') === "ALDI" && localStorage.getItem('liveuserRole') === "superadmin" &&(  */}
      {/* {( 
      <Box data-field="staffMemberDesc">
        <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
        {reportGroup === "ALDI" && 'Reviewers notes:'}<span style={{ color: "#D32F2F" }}> *</span>
        </Typography>
        <TextareaAutosize
          minRows={5}
          placeholder="Write Here..."
          value={staffMemberDesc}
          onChange={(e) => setStaffMemberDesc(e.target.value)}
          className={`summeryBox ${
            validationErrors.some((e) => e.field === "staffMemberDesc")
              ? "error-border"
              : ""
          }`}
          style={{
            borderColor: validationErrors.some(
              (e) => e.field === "staffMemberDesc"
            )
              ? "#d32f2f"
              : undefined,
            borderRadius: "10px",
          }}
        />
        <FieldError errors={validationErrors} field="staffMemberDesc" />
      </Box>
      )} */}

      {addOnQuestionsData.length !== 0 && (
        <Box>
          <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
            Additional Questions
          </Typography>
          <Grid container spacing={3}>
            {addOnQuestionsData.map((addOnQuestion) => (
              <Grid
                sx={{ width: "50%" }}
                item
                xs={12}
                md={6}
                key={addOnQuestion.reportAddOnQuestionId}
                data-field={`addOnQuestionField_${addOnQuestion.reportAddOnQuestionId}`}
              >
                <Box className='d-flex align-items-center mb-1' gap={1}>
                  <label>
                    {addOnQuestion.addOnQuestionText}{" "}
                    <span style={{ color: "#D32F2F" }}> *</span>
                  </label>
                  {isAdmin && (
                    <Tooltip title='see history'>
                      <IconButton onClick={() => { getHistory(`?reportHeaderId=${reportDetailsHeader?.reportHeaderId}&reportAddOnQuestionId=${addOnQuestion.reportAddOnQuestionId}`) }} className="m-0 p-0">
                        <HistoryOutlined />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
                {(() => {
                  const { addOnQuestionType, reportAddOnQuestionId } = addOnQuestion;
                  const fieldKey = reportAddOnQuestionId.toString();
                  const value = localAddOnValues[fieldKey] || "";

                  // TIME PICKER
                  if (addOnQuestionType === "time") {
                    return (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          value={value ? dayjs(value, "HH:mm") : null}
                          onChange={(newValue) => {
                            const formatted = newValue ? newValue.format("HH:mm") : "";
                            handleLocalChange(fieldKey, formatted);   // ⚡ only update local state
                            handleBlur(fieldKey, formatted);
                          }}

                          slotProps={{
                            textField: {
                              fullWidth: true, variant: "outlined", onBlur: (e) => {
                                handleBlur(fieldKey, value);
                              }
                            }
                          }}
                        />
                      </LocalizationProvider>
                    );
                  }

                  // TEXT INPUT
                  if (addOnQuestionType === "text") {
                    return (
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={value}
                        name={`addOnQuestionField_${fieldKey}`}
                        onChange={(e) => handleLocalChange(fieldKey, e.target.value)}   // ⚡ local only
                        onBlur={(e) => handleBlur(fieldKey, e.target.value)}            // 🟢 save once
                        placeholder="Enter text"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <MicButton
                                onClick={() =>
                                  setVoiceTarget({ type: "addOn", key: fieldKey, title: addOnQuestion.addOnQuestionText })
                                }
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    );
                  }

                  // LONG TEXT
                  return (
                    <Box sx={{ position: "relative" }}>
                      <textarea
                        rows={5}
                        placeholder="Enter detailed text"
                        style={{
                          width: "100%",
                          padding: "16.5px 14px",
                          borderRadius: 4,
                          border: "1px solid #ccc",
                          whiteSpace: "break-spaces",
                        }}
                        name={`addOnQuestionField_${fieldKey}`}
                        defaultValue={value}
                        onChange={(e) => handleLocalChange(fieldKey, e.target.value)}     // ⚡ local only
                        onBlur={(e) => handleBlur(fieldKey, e.target.value)}              // 🟢 save on blur
                      />
                      <MicButton
                        sx={{ position: "absolute", top: 8, right: 8 }}
                        onClick={() =>
                          setVoiceTarget({
                            type: "addOn",
                            key: fieldKey,
                            title: addOnQuestion.addOnQuestionText,
                          })
                        }
                      />
                    </Box>
                  );
                })()}

                {/* {(() => {
                  const { addOnQuestionType, reportAddOnQuestionId } = addOnQuestion;
                  const value = addOnQuestions[reportAddOnQuestionId] || "";

                  if (addOnQuestionType === "time") {
                    return (
                      // <TextField
                      //   fullWidth
                      //   variant="outlined"
                      //   name={`addOnQuestionField_${reportAddOnQuestionId}`}
                      //   value={value}
                      //   onChange={(e) =>
                      //     onAddOnQuestionChange(reportAddOnQuestionId.toString(), e.target.value)
                      //   }
                      //   type="time"
                      // />
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          // label="Select Time"
                          value={value ? dayjs(value, "HH:mm") : null}
                          onChange={(newValue) => {
                            const formatted = newValue ? newValue.format("HH:mm") : "";
                            onAddOnQuestionChange(reportAddOnQuestionId.toString(), formatted);
                          }}
                          slotProps={{ textField: { fullWidth: true, variant: "outlined" } }}
                        />
                      </LocalizationProvider>
                    );
                  }

                  if (addOnQuestionType === "text") {
                    return (
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={value}
                        name={`addOnQuestionField_${reportAddOnQuestionId}`}
                        onChange={(e) =>
                          onAddOnQuestionChange(reportAddOnQuestionId.toString(), e.target.value)
                        }
                        placeholder="Enter text"
                      />
                    );
                  }

                  // Default fallback → longText
                  return (
                    <textarea
                      rows={5}
                      placeholder="Enter detailed text"
                      style={{
                        width: "100%",
                        padding: "16.5px 14px",
                        borderRadius: 4,
                        border: "1px solid #ccc",
                        whiteSpace:'break-spaces'
                      }}
                      name={`addOnQuestionField_${reportAddOnQuestionId}`}
                      value={value}
                      onChange={(e) =>
                        onAddOnQuestionChange(reportAddOnQuestionId.toString(), e.target.value)
                      }
                    />
                  );
                })()} */}


                <FieldError
                  errors={validationErrors}
                  field={`addOnQuestionField_${addOnQuestion.reportAddOnQuestionId}`}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {briefJson.length !== 0 && (
        <Box>
          <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
            Summary
          </Typography>
          <Grid container spacing={3}>
            {briefJson.map((rop) => {
              const fieldKey = rop.reportBriefJsonId.toString();
              const currentValue = localTextInputs[fieldKey] || "";

              const hasError = validationErrors.some(
                (e) => e.field === `textInput_${rop.reportBriefJsonId}`
              );

              const wordCount = currentValue.trim().split(/\s+/).filter(Boolean).length;
              const matchedIssue = AiReviews?.summaryIssues?.find(
                (item: any) => item.title === rop.briefJsonTitle
              );


              const glow = keyframes`
                          0% {
                            filter: drop-shadow(0 0 4px #ff6a00);
                            transform: scale(1);
                          }
                          50% {
                            filter: drop-shadow(0 0 10px #ff0080);
                            transform: scale(1.1);
                          }
                          100% {
                            filter: drop-shadow(0 0 4px #ff6a00);
                            transform: scale(1);
                          }
                        `;
              return (
                <Grid
                  // key={key}
                  item
                  xs={12}
                  md={6}
                  key={rop.reportBriefJsonId}
                  // ref={(el: any) => (overviewRefs.current[key] = el)}
                  ref={(el) => {
                    if (el) {
                      summaryRefs.current[rop.reportBriefJsonId.toString()] = el;
                    }
                  }}
                  data-field={`textInput_${rop.reportBriefJsonId}`}
                >
                  <Box className='d-flex align-items-center mb-2' gap={1}>
                    <label>
                      {rop.briefJsonTitle}{" "}
                      <span style={{ color: "#D32F2F" }}> *</span>
                    </label>
                    <Tooltip title={rop.briefJsonDescription}>
                      <Info sx={{ fontSize: "16px" }} />
                    </Tooltip>
                    {matchedIssue && (
                      <Tooltip
                        title={
                          <>
                            <strong>{matchedIssue.issue}</strong>
                            <br />
                            {matchedIssue.description}
                          </>
                        }
                      >
                        <AutoAwesome />
                      </Tooltip>
                    )}
                    {isAdmin && (
                      <Tooltip title='see history'>
                        <IconButton onClick={() => { getHistory(`?reportHeaderId=${reportDetailsHeader?.reportHeaderId}&reportBriefJsonId=${rop.reportBriefJsonId}`) }} className="m-0 p-0">
                          <HistoryOutlined />
                        </IconButton>
                      </Tooltip>
                    )}

                  </Box>
                  <div className={`pb-0 border-10`} style={{ position: "relative" }}>
                    <textarea
                      rows={5}
                      placeholder={rop.briefJsonDescription}
                      value={currentValue}

                      onBlur={(e) => {
                        //  if (e.target.value === currentValue) return;  
                        onTextChange(fieldKey, e.target.value);
                        setTimeout(() => {
                          updateBriefJson(fieldKey, e.target.value);
                        }, 100);
                      }}
                      onChange={(e: any) => handleSummary(fieldKey, e.target.value)}
                      className={`summeryBox m-0 ${matchedIssue ? 'blink-border' : ''}  ${hasError ? "error-border" : ""}`}
                      // className={`summeryBox m-0 ${hasError ? "error-border" : ""}`}
                      style={{
                        borderColor: hasError ? "#d32f2f" : undefined,
                        borderRadius: "10px",
                        whiteSpace: "break-spaces",
                        // boxShadow: '0px 0px 10px rgba(0,0,0,0.1)', 
                        // Custom shadow
                        // textAlign:'left'
                      }}
                    />
                    <MicButton
                      sx={{ position: "absolute", top: 8, right: 8 }}
                      onClick={() =>
                        setVoiceTarget({ type: "summary", key: fieldKey, title: rop.briefJsonTitle })
                      }
                    />
                  </div>
                  <FieldError
                    errors={validationErrors}
                    field={`textInput_${rop.reportBriefJsonId}`}
                  />

                  <Typography variant="caption">
                    <span className="text-light bg-second px-2 border-10 py-1">
                      Min: {rop.minNoOfWords}
                    </span>
                    &nbsp;&nbsp;
                    <span className="border-10 bg-second text-light px-2 py-1">
                      Max: {rop.maxNoOfWords}
                    </span>
                    &nbsp;&nbsp;
                    <span className="text-light bg-second border-10 px-2 py-1">
                      Current: {wordCount}
                    </span>
                  </Typography>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      )}

      <Divider sx={{ mt: 4, borderBottom: "2px solid #ADB792" }} />

      <Typography variant="h5" fontWeight={600}>
        Check In
      </Typography>
      <Typography className="mt-0 fs-16">
        Please check-in with your location, if this doesn't work please upload photo of your maps location. You will not able to proceed without one of these.
      </Typography>

      <Box className='d-flex align-items-center gap-3'>
        <Button
          variant="contained"
          className="custom-bg text-dark py-1 fs-16 transform text-white px-auto"
          onClick={() => { handleCheckAction() }}
        >
          Check-In with location
        </Button>
        <Typography>or</Typography>
        <Button
          variant="contained"
          className="custom-bg text-dark py-1 fs-16 transform text-white px-auto"
          onClick={() => { setshowcheckIn(true) }}
        >
          Check-In with photo
        </Button>
      </Box>

      {(showcheckIn || validationErrors.some((e) => e.field === "checkInFile") || validationErrors.some((e) => e.field === "checkIntime") || uploadedFiles?.checkInFile?.some((item: any) => item.trim() !== "")) && (
        <>
          <Box>
            <FileUpload
              section="checkInFile"
              title="Check-In File"
              files={uploadedFiles.checkInFile}
              onUpload={onFileUpload}
              reorderFile={reorderFile}
              // onUpload={(event) => {
              //   const files = event.target.files;
              //   if (!files || files.length === 0) return;
              //   const file = files[0];
              //   handleOpenCropper(file, "checkInFile"); // pass correct section
              // }}
              onUpdate={onFileUpdate}
              onRemove={onRemoveFile}
              error={validationErrors.some((e) => e.field === "checkInFile")}
              errorMessage={
                validationErrors.find((e) => e.field === "checkInFile")?.message
              }
            />
            <FieldError errors={validationErrors} field="checkInFile" />
            {/* {cropperOpen && cropperFile && (
              <CropperModal
                file={cropperFile}
                onClose={() => setCropperOpen(false)}
                onSave={(croppedFile) => {
                  onFileUpload(
                    { target: { files: [croppedFile] } } as unknown as React.ChangeEvent<HTMLInputElement>,
                    cropperSection
                  );
                  setCropperOpen(false);
                }}
                reportgroup={reportGroup}
              />
            )} */}

          </Box>
          <Grid item xs={12} md={4}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <FormControl fullWidth>
                <InputLabel shrink={false}>
                  Check In Date  <span style={{ color: "#D32F2F" }}> *</span>
                </InputLabel>

                <DateTimePicker
                  value={checkIntime ? new Date(checkIntime) : null}
                  onChange={(newValue) => setcheckIntime(newValue)}
                  format="dd-MM-yyyy HH:mm"
                  minDateTime={
                    reportDetails?.reportHeader?.inspectionDateTime && !isAdmin
                      ? (() => {
                        const d = new Date(reportDetails.reportHeader.inspectionDateTime);
                        d.setHours(0, 0, 0, 0);
                        return d;
                      })()
                      : undefined
                  }
                  maxDateTime={
                    reportDetails?.reportHeader?.inspectionDateTime && !isAdmin
                      ? (() => {
                        const d = new Date(reportDetails.reportHeader.inspectionDateTime);
                        d.setHours(23, 59, 59, 999); // allow whole day
                        return d;
                      })()
                      : undefined
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: validationErrors.some((e) => e.field === "checkIntime"),
                      helperText:
                        validationErrors.find((e) => e.field === "checkIntime")?.message || "",
                    },
                  }}
                />
              </FormControl>
            </LocalizationProvider>
          </Grid>
        </>
      )}


      <Dialog open={openHistory} sx={{ maxWidth: "800px", mx: 'auto' }}>
        <Box className='d-flex mb-3 px-3 pt-3 bg-white w-100 align-items-center justify-content-between' position={'sticky'} top={0}>
          <Typography variant="h5" className="fw-bold">History</Typography>
          <IconButton onClick={() => { setReportHistory(null); setOpenHistory(false) }}>
            <CancelOutlined />
          </IconButton>
        </Box>
        <DialogContent>
          {resportHistory?.sort((a: any, b: any) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime())
            ?.map((item: any, index: number) => {
              // const localDate = new Date(item?.createdOn.replace(" ", "T") + "Z");
              const date = new Date(item?.createdOn + " GMT+1100");
              const local = date.toLocaleString();
              const handleCopy = (text: string, index: number) => {
                navigator?.clipboard?.writeText(text);
                setCopiedIndex(index);

                setTimeout(() => {
                  setCopiedIndex(null);
                }, 1500);
              };
              return (
                <Box className='pb-2 mb-3' borderBottom={'1px dashed #ccc'}>
                  <Box className='d-flex justify-content-end mb-1'>
                    <Typography className="fw-bold" variant="caption">{local.toLocaleString()} ({item?.email})</Typography>
                  </Box>
                  <Box className='d-flex align-items-start' gap={1}>
                    {!item?.teamMemberDescription && !item?.briefJsonAnswer && !item?.addOnQuestionValue ? (
                      <Box className='w-100 d-flex align-items-center justify-content-between'>
                        <Box>
                          <Typography><b>Score:</b> {item?.score}</Typography>
                          <Typography><b>Feedback:</b> {item?.feedback}</Typography>
                        </Box>
                        <Box>
                          <IconButton
                            size="small"
                            className="d-block"
                            onClick={() => handleCopy(item?.score, index)}
                          >
                            <ContentCopyOutlined fontSize="inherit" />
                          </IconButton>
                          {item?.feedback && (
                            <IconButton
                              size="small"
                              className="d-block"
                              onClick={() => handleCopy(item?.feedback, index)}
                            >
                              <ContentCopyOutlined fontSize="inherit" />
                            </IconButton>
                          )}
                        </Box>
                      </Box>
                    ) : (
                      <>
                        <Typography variant="body2" flex={1}>{item?.teamMemberDescription ?? item?.briefJsonAnswer ?? item?.addOnQuestionValue}</Typography>
                        <Tooltip title={copiedIndex === index ? "Copied" : "Copy"}>
                          <IconButton
                            size="small"
                            onClick={() => handleCopy(item?.teamMemberDescription ?? item?.briefJsonAnswer ?? item?.addOnQuestionValue, index)}
                          >
                            <ContentCopyOutlined fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </Box>
                </Box>
              )
            })}
        </DialogContent>
      </Dialog>

      <Dialog open={openAddManager} sx={{ maxWidth: "500px", mx: 'auto' }}>

        <DialogTitle className='m-0 mt-2 p-0' style={{ textAlign: "center" }}>
          Add Staff Member</DialogTitle>
        <DialogContent>
          <div className="form-group mb-0">
            <TextField
              label="Member Name"
              InputLabelProps={{
                shrink: false
              }}
              fullWidth
              size="small"
              sx={{ marginTop: "10px", boxShadow: 'none' }}
              value={managerName}
              onChange={(e) => setManagerName(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between', marginLeft: 2, marginRight: 2 }}>
          <Button
            variant="outlined"
            sx={{ color: '#ADB792', borderColor: '#ADB792', width: '100%' }}
            onClick={() => { setOpenAddManager(false); setManagerName("") }}
          >
            Cancel
          </Button>
          <Button
            className="custom-bg text-white"
            sx={{ width: '100%' }}

            onClick={() => {
              CretaeStaff();
            }}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openNetPromoterInfo}>
        <DialogTitle className='w-100 p-3' style={{ textAlign: "center" }}>
          <Box className="d-flex align-items-cneter w-100 justify-content-between">
            <Typography variant="h5" className="fw-bold">Net Promoter Score</Typography>
            <IconButton className="m-0 p-0" onClick={() => { setOpenNetPromoterInfo(false) }}>
              <CancelOutlined />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent className="p-3">
          <Box>
            <Typography variant="body2" className="mb-2 d-block">Based on your overall experience today, how likely would you be to recommend this business to a friend, family member or colleague?</Typography>
            <Typography gutterBottom variant="body2" className="d-block">Rate from 0 to 10, where:</Typography>
            <Typography variant="body2" className="d-block">10 = Extremely likely to recommend</Typography>
            <Typography variant="body2" className="d-block mb-2">0 = Not at all likely to recommend</Typography>
            <Typography variant="body2" className="d-block mb-2">Shopper Hint:</Typography>
            <Typography variant="body2" className="d-block">Consider your entire experience, from start to finish. Think about the service you received, the quality of the product or service, the atmosphere, value for money, and whether the business met your expectations. Rate how likely you would genuinely be to recommend this business based on today's visit, not on previous experiences or personal preferences. Please explain why you gave this score. Tell us the main reason for your rating.</Typography>
            <Typography variant="body2" className="d-block">Mention the key positive and/or negative aspects that most influenced your decision to recommend (or not recommend) the business.</Typography>
            <Table className="w-100">
              <TableHead className="w-100 m-0 p-0">
                <TableRow>
                  <TableCell><Typography variant="body2" className="d-block">Score</Typography></TableCell>
                  <TableCell><Typography variant="body2" className="d-block">Meaning</Typography></TableCell>
                  <TableCell><Typography variant="body2" className="d-block">Guidance</Typography></TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="w-100 m-0 p-0">
                <TableRow>
                  <TableCell><Typography variant="body2" className="d-block">9–10</Typography></TableCell>
                  <TableCell><Typography variant="body2" className="d-block">Extremely likely</Typography></TableCell>
                  <TableCell><Typography variant="body2" className="d-block">Outstanding experience. Very few, if any, improvements could be made.</Typography></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Typography variant="body2" className="d-block">7–8</Typography></TableCell>
                  <TableCell><Typography variant="body2" className="d-block">Likely</Typography></TableCell>
                  <TableCell><Typography variant="body2" className="d-block">Good experience with some minor areas for improvement.</Typography></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Typography variant="body2" className="d-block">5–6</Typography></TableCell>
                  <TableCell><Typography variant="body2" className="d-block">Neutral</Typography></TableCell>
                  <TableCell><Typography variant="body2" className="d-block">Average experience. Positives and negatives balanced.</Typography></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Typography variant="body2" className="d-block">3–4</Typography></TableCell>
                  <TableCell><Typography variant="body2" className="d-block">Unlikely</Typography></TableCell>
                  <TableCell><Typography variant="body2" className="d-block">Several aspects of the experience fell below expectations.</Typography></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Typography variant="body2" className="d-block">0–2</Typography></TableCell>
                  <TableCell><Typography variant="body2" className="d-block">Extremely unlikely</Typography></TableCell>
                  <TableCell><Typography variant="body2" className="d-block">Very poor experience with significant issues.</Typography></TableCell>
                </TableRow>
              </TableBody>
            </Table>

          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between', marginLeft: 2, marginRight: 2 }}>
          <Button
            className="custom-bg text-white"
            sx={{ width: '100%' }}
            onClick={() => {
              setOpenNetPromoterInfo(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>


      <VoiceInputDialog
        open={!!voiceTarget}
        title={voiceTarget?.title || "Voice input"}
        initialText={getVoiceInitialText(voiceTarget)}
        onClose={() => setVoiceTarget(null)}
        clientGroup={clientGroup}
        onDone={(text) => voiceTarget && applyVoiceText(voiceTarget, text)}
      />

    </Stack>
  );
});

export default RateYourExperience;
